import React from 'react';
import get from 'lodash/get';
import { useIntl } from 'react-intl-next';
import { DatePicker } from '@atlaskit/datetime-picker';
import { fg } from '@atlaskit/platform-feature-flags';
import { DEFAULT_LOCALE } from '../../../../intl-provider/ProFormaIntlProvider';
import { DEFAULT_WEEK_START_DAY, getLocale } from '../../../utils/localeUtils';
import { getInputAccessibilityDescriptionId } from '../common/accessibilityUtils';
import { ShortFieldWrapper } from '../common/questionWrappers';
import { EditDateMessages, IntlEditDateMessages } from './EditDateMessages.intl';
export var EditDate = function EditDate(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    descriptionId = _ref.descriptionId,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label;
  var intl = useIntl();
  var startOfWeekDay = get(getLocale(intl.locale), 'options.weekStartsOn', DEFAULT_WEEK_START_DAY);
  return /*#__PURE__*/React.createElement(ShortFieldWrapper, null, /*#__PURE__*/React.createElement(DatePicker, {
    id: id,
    value: value,
    isInvalid: isInvalid,
    isRequired: isRequired,
    onChange: onChange,
    locale: intl.locale || DEFAULT_LOCALE,
    placeholder: intl.formatMessage(IntlEditDateMessages[EditDateMessages.DatePlaceholder], {
      date: intl.formatDate(new Date(), {})
    }),
    label: fg('jsm-accessibility-fixes') ? undefined : label,
    weekStartDay: startOfWeekDay,
    shouldShowCalendarButton: fg('dst-init-calendar-button-proforma-editdate') ? true : undefined,
    "aria-describedby": fg('jsm-accessibility-fixes') ? getInputAccessibilityDescriptionId(errorId, descriptionId, isInvalid) : undefined
  }));
};